/**
 * Representa a cor do toast.
 */
enum ToastColor {
  /** Cor destaque do tema. */
  FeaturedColor = "featured",

  /** Cor de realçe do tema. */
  AccentColor = "accent",

  /** Cor de sucesso. */
  SuccessColor = "success",

  /** Cor de alerta. */
  AlertColor = "alert",

  /** Cor de cuidado. */
  WarningColor = "warning"
}
